"use client";

import { Avatar, Button, Flex, Popover, Text } from "@chakra-ui/react";
import PopOverComp from "./PopOverComp";
import { ImageBasic } from "./Image";
import { useDispatch, useSelector } from "react-redux";
import { setUserData } from "../redux";
import { IoIosArrowDown } from "react-icons/io";
import utils from "../utils";
import { useLocation } from "react-router-dom";
import { ColorModeButton } from "./ColorModeButton";

// const size = "md";
// const imgurl = "https://placebeard.it/250/250";

export const HeaderMain = ({ label, isLoading }) => {
  const userData = useSelector((state) => state.userData);
  const dispatch = useDispatch();
  const { pathname } = useLocation();

  const onLogout = async () => {
    await utils.logout({ dispatch, setUserData });
  };

  if (
    pathname === "" ||
    pathname?.substring(1) === "" ||
    pathname?.substring(1) === "forgotpassword" ||
    pathname?.substring(1) === "resetpassword"
  ) {
    return null;
  }

  return (
    <Flex
      justify={"space-between"}
      p={"1px"}
      px={"1rem"}
      boxShadow={"sm"}
      borderBottomWidth={"0.5px"}
      borderColor={"shadow"}
      // boxShadowColor={"var(--chakra-shadows-base)"}
      // boxShadow="var(--chakra-shadows-base)"
      // var(--chakra-colors-gray-200);
    >
      <Button
        variant={"ghost"}
        onClick={() => {
          window.location.href = "/";
        }}
        h={"55px"}
      >
        <ImageBasic
          alignSelf={"start"}
          // p={"1rem"}
          // ml={"1rem"}
          src={utils.getUserCustomData({
            userData: userData,
            key: "brandlogo",
          })}
          // w={"8rem"}
          objectFit="contain"
          h={"55px"}
          // w={"200px"}

          alt="Logo"
        />
      </Button>
      <Flex alignItems={"center"} gap={"1rem"}>
        <ColorModeButton />
        {userData?.userid ? (
          <PopOverComp
            TriggerComp={
              <Flex alignItems={"center"} gap={"1rem"}>
                <Avatar.Root>
                  {/* <Avatar.Fallback
                    name={`${userData?.firstname || ""} ${
                      userData?.lastname || ""
                    }`}
                  /> */}
                  {/* <Avatar.Image src={imgurl} /> */}
                  {/* <Avatar.Context> */}
                  {/* </Avatar.Context> */}
                </Avatar.Root>
                <Text>
                  {`${userData?.firstname || ""} ${userData?.lastname || ""}`}
                </Text>
                <IoIosArrowDown />
              </Flex>
            }
            Body={
              <Popover.Body>
                <Flex overflow={"hidden"} gap={"0.5rem"} direction={"column"}>
                  {/* <Popover.Title fontWeight="medium">Profile</Popover.Title> */}
                  {/* <Text>{`${userDataL?.firstname || ""} ${
                  userDataL?.lastname || ""
                }`}</Text> */}
                  <Button variant={"ghost"} w={"10rem"} onClick={onLogout}>
                    Logout
                  </Button>
                </Flex>
              </Popover.Body>
            }
          />
        ) : null}
      </Flex>
    </Flex>
  );

  // return null;

  // return (
  //   <Flex
  //     w={"100%"}
  //     overflow={"hidden"}
  //     alignItems={"center"}
  //     gap={"1rem"}
  //     mb={"1rem"}
  //     // justify={"space-between"}
  //     pr={"2rem"}
  //   >
  //     <Flex alignItems={"center"} gap={"1rem"}>
  //       {/* <Heading size="4xl" color="primary" mt="2.5" mb="2.5" lineClamp={1}>
  //         {label || ""}
  //       </Heading> */}
  //       {isLoading ? (
  //         <Spinner size="md" color="colorPalette.600" colorPalette={"green"} />
  //       ) : null}
  //     </Flex>
  //   </Flex>
  // );
};

// <Flex alignItems={"center"}>
//   <PopOverComp
//     TriggerComp={
//       <Flex>
//         <Avatar.Root size={"xl"}>
//           <Avatar.Fallback name="Parmar Vishal" />
//           <Avatar.Image src={imgurl} />
//           {/* <Avatar.Context>
//     </Avatar.Context> */}
//         </Avatar.Root>
//       </Flex>
//     }
//     Body={
//       <Popover.Body>
//         <Flex overflow={"hidden"} gap={'0.5rem'} direction={'column'}>
//           {/* <Popover.Title fontWeight="medium">Profile</Popover.Title> */}
//           <Text>Parmar Vishal</Text>
//           <Button variant={"ghost"} w={'10rem'}>Logout</Button>
//         </Flex>
//       </Popover.Body>
//     }
//   />
// </Flex>
